export default "__VITE_ASSET__ca0bdfb6__"